<template>
  <div class="course-banner-warpper" v-if="liveCourse">
    <img class="bg" :src="liveCourse.course_properties.imgUrl" alt  v-if="liveCourse.course_properties && liveCourse.course_properties.imgUrl"/>
    <img class="bg" src="img/live1bg.png" alt  v-else/>
    <div class="course-banner-contents">
      <h5 class="heading" @click="redirectToDescription">
        {{ liveCourse.name }}
      </h5>
      <div class="pills">
        <div class="pill first">{{ liveCourse.course_properties.subject }}</div>
        <div class="pill second">₹{{ liveCourse.price }}</div>
      </div>
      <div class="status">
        <div class="conductedby" v-if="!(getUserRole === 'teacher')">
          <img
            :src="liveCourse.profile_photo"
            alt
            srcset
            v-if="liveCourse.profile_photo"
          />
          <img src="https://placeimg.com/50/50/person" alt srcset v-else />
          <span>Conducted by</span>
          <p>{{ liveCourse.teacher_name }}</p>
        </div>
        <div class="time">
          <font-awesome-icon icon="clock"></font-awesome-icon>
          <span>Live at</span>
          <p>{{ timein }}</p>
        </div>
      </div>
      <div class="button-holder">
        <b-button size="lg" pill variant="primary" @click="playLiveVideo">
          <span>{{ buttonText }}</span>
          <font-awesome-icon icon="arrow-right" size="xs" />
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from "../../store/store";
import { mapGetters, mapActions } from "vuex";
import { commonFunctions } from "../../Commonjs/commonFunctions";

export default {
  name: "course_banner",
  data() {
    return {
      buttonText: "Enroll Now",
      timein: "",
      show: false
    };
  },
  props: {
    liveCourse: Object
  },
  methods: {
    playLiveVideo() {
      // this.$emit(
      //   "playLiveVideo",
      //   this.liveCourse.room_number,
      //   this.liveCourse.course_id
      // );
      store.dispatch("courses/setLiveCourse", true);
      this.$router.push({
        path: "/course_description",
        query: { courseId: this.liveCourse.course_id, courseType: "liveCourse" }
      });
      //   if (this.isAuthenticated && this.getUserRole === "teacher") {
      //       if (this.getTeacherLiveCourses.length > 0 && this.getTeacherLiveCourses.some(
      //               courseD => courseD.course_id === this.liveCourse.course_id
      //           )) {
      //           this.$router.push({
      //               path: "/live_start",
      //               query: {
      //                   room_number: this.liveCourse.room_number,
      //                   course_id : this.liveCourse.course_id,
      //               }
      //           });
      //       }else if(this.getSubscribedLiveCourses.length > 0 && this.getSubscribedLiveCourses.some(
      //               courseD => courseD.course_id === this.liveCourse.course_id
      //           )){
      //           this.videoUrl = `https://studiov2.lyceum.one/webrtc/?room=${room_number}`;
      //           this.$bvModal.show("video-modal");
      //       } else {
      //           store.dispatch("courses/setLiveCourse", true);
      //           this.$router.push({
      //               path: "/course_description",
      //               query: { courseId: this.liveCourse.course_id, courseType: "liveCourse" }
      //           });
      //       }
      //   } else if (this.isAuthenticated && this.getUserRole === "student") {
      //       if (this.getSubscribedLiveCourses.length > 0 && this.getSubscribedLiveCourses.some(
      //               courseD => courseD.course_id === this.liveCourse.course_id
      //           )) {
      //           this.videoUrl = `https://studiov2.lyceum.one/webrtc/?room=${this.liveCourse.room_number}`;
      //           this.$bvModal.show("video-modal");
      //       } else {
      //           store.dispatch("courses/setLiveCourse", true);
      //           this.$router.push({
      //               path: "/course_description",
      //               query: { courseId: this.liveCourse.course_id, courseType: "liveCourse" }
      //           });
      //       }
      //   } else {
      //       store.dispatch("courses/setLiveCourse", true);
      //       this.$router.push({
      //           path: "/course_description",
      //           query: { courseId: this.liveCourse.course_id, courseType: "liveCourse" }
      //       });
      //   }
    },
    buttonTextToggle() {
      if (this.isAuthenticated && this.getUserRole === "teacher") {
        if (
          this.getTeacherLiveCourses.length > 0 &&
          this.getTeacherLiveCourses.some(
            courseD => courseD.course_id === this.liveCourse.course_id
          )
        ) {
          this.buttonText = "Start Now";
        } else if (
          this.getSubscribedLiveCourses.length > 0 &&
          this.getSubscribedLiveCourses.some(
            courseD => courseD.course_id === this.liveCourse.course_id
          )
        ) {
          this.buttonText = "Watch Now";
        } else {
          this.buttonText = "Enroll Now";
        }
      } else if (this.isAuthenticated && this.getUserRole === "student") {
        if (
          this.getSubscribedLiveCourses.length > 0 &&
          this.getSubscribedLiveCourses.some(
            courseD => courseD.course_id === this.liveCourse.course_id
          )
        ) {
          this.buttonText = "Watch Now";
        } else {
          this.buttonText = "Enroll Now";
        }
      } else {
        this.buttonText = "Enroll Now";
      }
    },
    redirectToDescription() {
      store.dispatch("courses/setLiveCourse", true);
      this.$router.push({
        path: "/course_description",
        query: { courseId: this.liveCourse.course_id, courseType: "liveCourse" }
      });
    }
  },
  computed: {
    ...mapGetters("user", [
      "isAuthenticated",
      "getUserRole",
      "getUserDetails",
      "getSubscribedLiveCourses",
      "getTeacherLiveCourses"
    ])
  },
  mounted() {
    this.buttonTextToggle();
    let options = {weekday: 'long',hour:'numeric',minute:'numeric'};
    if( this.liveCourse && this.liveCourse.videos) {
        this.liveCourse.videos.forEach(video => {
            if (new Date(video.start_time).getTime() > new Date().getTime()) {
                this.timein = new Date(this.liveCourse.videos[0].start_time).toLocaleDateString('en-US', options)
            }
        })
    }
  },
  watch: {
    isAuthenticated() {
      this.buttonTextToggle();
    }
  }
};
</script>

<style></style>
